import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IPaymentMethodSummary } from 'gen/ApiClient';
import React from 'react';

export const PaymentMethodsPreloadCacheContext = React.createContext<IPreloadCacheContext<IPaymentMethodSummary[]>>(undefined as any);
